import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import startsWith from 'lodash/startsWith';
import get from 'lodash/get';
import { useLocationPageNames } from 'modules/core';
import { NavBar, NavBarLink } from 'modules/ui';
import {
  AccountAvatarMenu,
  AccountNavBarEnvelope,
  PRODUCER_PAGES,
} from 'modules/accounts';
import { getProducer } from '../redux';
import { useLocation, useNavigate } from 'react-router-dom';

function ProducerNavBar({ avatar, onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPage = useLocationPageNames(PRODUCER_PAGES.PAGES);
  const producer = useSelector(getProducer);

  const fullName = get(producer, 'fullName');
  const city = get(producer, 'city');
  const state = get(producer, 'state.name');
  const country = get(producer, 'country.name');

  function handleProfileClick() {
    navigate('/profile');
  }

  function handleEditProfileClick() {
    navigate('/profile/edit');
  }

  function handleSettingsClick() {
    navigate('/settings/change-password');
  }

  return (
    <NavBar
      activePageName={currentPage}
      rightIconComponent={<AccountNavBarEnvelope />}
      showMobile={false}
      className="pt-4"
    >
      <NavBarLink
        to="/"
        id="projects-link"
        isExtraUrlMatch={
          location.pathname === '/' ||
          startsWith(location.pathname, '/projects') ||
          startsWith(location.pathname, '/auditions')
        }
      >
        Projects
      </NavBarLink>
      <NavBarLink to="/search" id="search-link">
        Talent Search
      </NavBarLink>
      <NavBarLink to="/lists" id="lists-link">
        Lists
      </NavBarLink>
      <AccountNavBarEnvelope />
      <AccountAvatarMenu
        avatar={avatar}
        fullName={fullName}
        city={city}
        state={state}
        country={country}
        onLogout={onLogout}
        onProfile={handleProfileClick}
        onEditProfile={handleEditProfileClick}
        onSettings={handleSettingsClick}
        isActive={startsWith(location.pathname, '/profile')}
        enableHoverBorder
      />
    </NavBar>
  );
}

ProducerNavBar.propTypes = {
  onLogout: PropTypes.func,
  avatar: PropTypes.string,
};

export default ProducerNavBar;
